import type { GeneralResp } from '@/models/GeneralResp';
import type { AxiosResponse } from 'axios';
import * as ApiClient from '@/libs/ApiClient';
import { RouteUrlList } from '@/libs/RouteList';

/**
 * @todo Api 回傳值
 */
export interface ConfirmationPostBackResp extends GeneralResp {}

/**
 * @todo 資料確認
 *
 */
const ConfirmationPostBack = (): Promise<ConfirmationPostBackResp> => {
    const url = RouteUrlList.API_ConfirmationPostBack.path;
    const config = {
        params: { showOverlay: ApiClient.paramTypeEnum.true, getServiceAlert: ApiClient.paramTypeEnum.true }
    };
    return ApiClient.post(url, {}, config).then((res: AxiosResponse<ConfirmationPostBackResp>) => {
        return res.data;
    });
};

export default ConfirmationPostBack;
